<template>
  <div class="arrears-contract-container">
    <!-- 搜索操作区域 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>欠费催缴管理</span>
      </div>

      <el-row :gutter="20">
        <!-- 合同ID搜索 -->
        <el-col :span="6">
          <el-input
            v-model.trim="searchForm.contractId"
            placeholder="请输入合同ID"
            clearable
            prefix-icon="el-icon-search"
          />
        </el-col>

        <!-- 签约时间区间 -->
        <el-col :span="12">
          <el-date-picker
            v-model="searchForm.signDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="签约开始时间"
            end-placeholder="签约结束时间"
            value-format="yyyy年MM月dd日"
            style="width: 100%"
          />
        </el-col>

        <!-- 操作按钮 -->
      </el-row>

      <el-row style="margin-top: 15px" :gutter="20">
        <el-col :span="8">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 欠费列表区域 -->
    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="arrearsList"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        ref="arrearsTable"
      >
        <!-- 多选列 -->
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column prop="contractId" label="合同ID" min-width="180" show-overflow-tooltip />
        <el-table-column prop="paymentNo" label="付款序号" width="90" align="center" />
        <el-table-column prop="paymentDate" label="付款日期" width="140" align="center" />
        <el-table-column prop="startDate" label="租赁起始日期" width="140" align="center" />
        <el-table-column prop="endDate" label="租赁截止日期" width="140" align="center" />
        <el-table-column prop="rentalDays" label="计租天数" width="90" align="center" />
        <el-table-column prop="rentAmount" label="合计应付金额(元)" min-width="140" align="right">
          <template slot-scope="scope">
            {{ Number(scope.row.rentAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="rentOnlyAmount" label="租金金额(元)" min-width="120" align="right">
          <template slot-scope="scope">
            {{ Number(scope.row.rentOnlyAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="heatingOnlyAmount" label="采暖金额(元)" min-width="120" align="right">
          <template slot-scope="scope">
            {{ Number(scope.row.heatingOnlyAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="paymentAmount" label="已缴金额(元)" min-width="120" align="right">
          <template slot-scope="scope">
            {{ scope.row.paymentAmount ? Number(scope.row.paymentAmount).toFixed(2) : "0.00" }}
          </template>
        </el-table-column>
        <el-table-column label="欠费金额(元)" min-width="120" align="right">
          <template slot-scope="scope">
            {{ (Number(scope.row.rentAmount) - Number(scope.row.paymentAmount || 0)).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="paymentAmountTime" label="缴费时间" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.paymentAmountTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="invoiceStatus" label="是否开具发票" width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.invoiceStatus === "1" ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="preInvoiceStatus" label="是否预开发票" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.preInvoiceStatus === "1" ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="isPayStatus" label="是否上缴" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.isPayStatus === "1" ? "是" : "否" }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row
        style="
          margin-top: 15px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <el-pagination
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {
  queryArrearsContractNew
} from "@/api/contract/arrearsContractApi";

export default {
  name: "QueryArrearsContract",
  data() {
    return {
      loading: false,
      exportLoading: false,

      // 搜索表单
      searchForm: {
        contractId: "",
        signDateRange: []
      },

      // 表格数据
      arrearsList: [],
      selectedList: [],

      // 分页配置
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    this.fetchArrearsList();
  },
  methods: {
    // ========== 多选事件 ==========
    handleSelectionChange(val) {
      this.selectedList = val;
    },

    // ========== 查询欠费列表 ==========
    async fetchArrearsList() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          contractId: this.searchForm.contractId,
          startSignDate: this.searchForm.signDateRange[0] || "",
          endSignDate: this.searchForm.signDateRange[1] || ""
        };
        const res = await queryArrearsContractNew(params);
        if (res.code === 0) {
          this.arrearsList = res.data || [];
          this.pagination.total = res.total || 0;
        } else {
          this.$message.error(res.msg || "查询欠费数据失败");
        }
      } catch (error) {
        console.error("查询欠费列表异常：", error);
        this.$message.error("查询欠费列表失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.current = 1;
      this.$refs.arrearsTable.clearSelection();
      this.selectedList = [];
      this.fetchArrearsList();
    },

    // 重置搜索
    handleReset() {
      this.searchForm = {
        contractId: "",
        signDateRange: []
      };
      this.handleSearch();
    },

    // 每页条数改变：接收新size并赋值
    handleSizeChange(newSize) {
      this.pagination.size = newSize;
      this.pagination.current = 1; // 切换条数回到第一页
      this.$refs.arrearsTable.clearSelection();
      this.selectedList = [];
      this.fetchArrearsList();
    },

    // 页码切换：接收新页码并赋值
    handleCurrentChange(newPage) {
      this.pagination.current = newPage;
      this.$refs.arrearsTable.clearSelection();
      this.selectedList = [];
      this.fetchArrearsList();
    },
  },
};
</script>

<style lang="scss" scoped>
.arrears-contract-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .table-card {
    .el-table {
      --el-table-header-text-color: #333;
      --el-table-row-hover-bg-color: #f5f7fa;
    }

    .el-pagination {
      text-align: right;
    }
  }
}
</style>